<template>
	<v-text-field
		v-bind="$attrs"
		variant="outlined"
	>
		<template #message="{ message }">
			{{ $gettext(message) }}
		</template>
	</v-text-field>
</template>

<script>

/**
 * Useful when using rules inside your text field to get errors properly translated
 */
export default {
	name: 'TextField'
};
</script>
